import { useRef } from "react";

import Button from "@stadium/shared/src/components/shared/button";
import Brands from "@stadium/ui/src/components/brands/responsive";
import SlidePanel, {
  slideOutPanel,
} from "@components/swagmagic/header-mobile-nav-menu/slide-panel";

import styles from "../main.module.scss";

interface BrandSliderProps {
  onBack: () => void;
  onClose: () => void;
}

const BrandSlider = ({ onBack, onClose }: BrandSliderProps) => {
  const panelRef = useRef<HTMLDivElement>(null);

  const handleBackClick = () => {
    slideOutPanel({
      panelRef,
      duration: 0.3,
      ease: "power2.in",
      onComplete: onBack,
    });
  };

  return (
    <SlidePanel panelRef={panelRef} className={styles.brandSliderPanel} duration={0.35}>
      <div className={styles.header}>
        <Button
          styleType="no-style"
          onClick={handleBackClick}
          className={styles.closeButton}
          aria-label="Back to menu"
        >
          <span className={styles.activeArrowIcon} />
          <p className={styles.categoryText}>Our Brands</p>
        </Button>
        <Button
          onClick={onClose}
          className={styles.closeButton}
          aria-label="Close menu"
          styleType="no-style"
        >
          <span className={styles.closeButtonIcon} />
        </Button>
      </div>
      <div className={styles.brandSliderContent}>
        <Brands isNextImage={false} />
      </div>
    </SlidePanel>
  );
};

export default BrandSlider;
